import React, { useEffect, useState } from 'react';
import { Modal, notify, Dropdown } from 'app/components';

import VenueDropdown from '../../../event-create/components/step-1/venueDropdown';
import EventAddress from '../../../event-create/components/step-1/eventAddress';
import EventMap from '../../../event-create/components/step-1/eventMap';
import { MAP_API_KEY } from '../../../event-create/constants';
import { INDIAN_CITIES } from '../../../event-create/constants/data';

const VenueModal = ({ show, onClose, isAdmin, onChange, formData }) => {
  const [currentScreen, setCurrentScreen] = useState('venueDropdown');
  const [title, setTitle] = useState('Edit venue location');
  const [data, setData] = useState(formData);

  useEffect(() => {
    setData(formData);
  }, [formData]);

  const validateVenueData = () => {
    if (!data?.event_address?.name?.trim()) {
      notify('error', 'Please enter a venue name to continue');
      return false;
    }
    if (!data?.event_address?.address_line_1?.trim()) {
      notify('error', 'Please enter the venue address to continue');  
      return false;
    }
    if (!data?.event_address?.city?.trim()) {
      notify('error','Please select a city for the venue');
      return false;
    }
    return true;
  };

  const handlePrimaryCta = () => {
    if (currentScreen === 'venueDropdown') {
      setTitle('Confirm venue location');
      setCurrentScreen('venueAddress');
    } else if (currentScreen === 'venueAddress') {
      if (!validateVenueData()) return;
      setTitle('Pin the location');
      setCurrentScreen('venueMap');
    } else if (currentScreen === 'venueMap') {
      if (!validateVenueData()) return;
      onChange(data, 'Location updated successfully', onClose);
    }
  };

  const handleVenuCancel = () => {
    if (currentScreen === 'venueMap') {
      setTitle('Confirm venue location');
      setCurrentScreen('venueAddress');
    } else if (currentScreen === 'venueAddress') {
      setTitle('Edit venue location');
      setCurrentScreen('venueDropdown');
    } else {
      onClose();
    }
  };

  const onChangeCity = (id, menuItem) => {
    if (id !== data?.geo_location) {
      setData({
        ...data,
        geo_location: id,
        event_address: {
          location: {
            lat: menuItem?.Latitude,
            lng: menuItem?.Longitude,
          },
          state: menuItem?.State,
        },
      });
    }
  };

  // const fetchCoordinates = async (address) => {
  //   const formattedAddress = `${address.venue}, ${address.address_line_1}, ${address.address_line_2}, ${address.city}`;
  //   if (!formattedAddress) return;

  //   const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(formattedAddress)}&key=${MAP_API_KEY}`);
  //   const data = await response.json();
  //   if (data.results && data.results[0]) {
  //     const { lat, lng } = data.results[0].geometry.location;
  //     setData({ ...data, markerPosition: { lat, lng } });
  //   }
  // };

  return (
    show && (
      <Modal size="medium" 
        className="modal-venue" 
        title={title} 
        hasClose={true} 
        primaryText={currentScreen === 'venueMap' ? 'Confirm' : 'Next'} 
        secondaryText={currentScreen === 'venueDropdown' ? 'Cancel' : 'Back'} 
        onClickPrimaryCta={handlePrimaryCta} 
        onClickSecondaryCta={handleVenuCancel}
        onClose={onClose}>

        {currentScreen === 'venueDropdown' && 
            <>
              {
                isAdmin &&
                <Dropdown width="100%"
                  className="mb-5"
                  label="City"
                  options={INDIAN_CITIES}
                  value={data?.geo_location}
                  hasSearch={true}
                  onChange={onChangeCity}
                />
              }
              <VenueDropdown showHeader={false} 
                formData={data} 
                setFormData={setData} 
              />
            </>
        }

        {currentScreen === 'venueAddress' && 
            <EventAddress 
              showHeader={false} 
              formData={data} 
              setFormData={setData}
            />
        }

        {currentScreen === 'venueMap' && 
            <EventMap showHeader={false} 
              formData={data} 
              setFormData={setData} 
            />
        }
        
      </Modal>
    )
  );
};

export default VenueModal;
